import { render, staticRenderFns } from "./TetrisView.vue?vue&type=template&id=8a2cba5a&scoped=true&lang=pug"
import script from "./TetrisView.vue?vue&type=script&lang=js"
export * from "./TetrisView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2cba5a",
  null
  
)

export default component.exports